import { render, staticRenderFns } from "./InventarioTableEstandarizados.vue?vue&type=template&id=54535082&scoped=true&"
import script from "./InventarioTableEstandarizados.vue?vue&type=script&lang=js&"
export * from "./InventarioTableEstandarizados.vue?vue&type=script&lang=js&"
import style0 from "./InventarioTableEstandarizados.vue?vue&type=style&index=0&id=54535082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54535082",
  null
  
)

export default component.exports